var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconbellgrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C5.44444 1 3.66667 3.50721 3.66667 6.6V8.33333C3.66667 9.4379 2.67308 10.3503 1.87601 11.115C1.36239 11.6078 1 12.3066 1 13.1333C1 14.1643 1.79594 15 2.77778 15H15.2222C16.2041 15 17 14.1643 17 13.1333C17 12.3066 16.6376 11.6078 16.124 11.115C15.3269 10.3503 14.3333 9.4379 14.3333 8.33333V6.6C14.3333 3.50721 12.5556 1 9 1Z",
    stroke: "#404040",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18C10.7968 18.3031 10.505 18.5547 10.154 18.7295C9.80302 18.9044 9.40506 18.9965 9 18.9965C8.59494 18.9965 8.19698 18.9044 7.84598 18.7295C7.49498 18.5547 7.20325 18.3031 7 18",
    stroke: "#404040",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconbellgrey);
export default __webpack_public_path__ + "static/media/Iconbellgrey.ad8085fea8ae10db6611c701f579bff7.svg";
export { ForwardRef as ReactComponent };